module.exports = {
  "closeImg": {
    "position": "relative"
  },
  "closeBox": {
    "width": "100",
    "height": "50",
    "position": "absolute",
    "left": 0
  },
  "dof-noticebar": {
    "width": "750",
    "paddingTop": "20",
    "paddingBottom": "20",
    "paddingLeft": "32",
    "paddingRight": "32",
    "backgroundColor": "rgba(0,0,0,0.1)",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "dof-noticebar-center": {
    "width": "750",
    "paddingTop": "20",
    "paddingBottom": "20",
    "paddingLeft": "32",
    "paddingRight": "32",
    "backgroundColor": "rgba(0,0,0,0.1)",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "noticebar-content": {
    "fontFamily": "'PingFangSC-Regular'",
    "fontSize": "26",
    "lineHeight": "34",
    "color": "#ffffff",
    "flex": 1,
    "lines": 4,
    "wordBreak": "break-all",
    "textOverflow": "ellipsis"
  },
  "noticebar-content-center": {
    "fontFamily": "'PingFangSC-Regular'",
    "fontSize": "26",
    "lineHeight": "34",
    "color": "#ffffff",
    "lines": 1,
    "textOverflow": "ellipsis"
  },
  "more-click-content": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "marginLeft": "16"
  },
  "btnText": {
    "fontSize": "24",
    "color": "#ffffff",
    "borderStyle": "solid",
    "borderWidth": "2",
    "borderTopColor": "rgba(255,255,255,0.5)",
    "borderBottomColor": "rgba(255,255,255,0.5)",
    "borderLeftColor": "rgba(255,255,255,0.5)",
    "borderRightColor": "rgba(255,255,255,0.5)",
    "borderRadius": "48",
    "lineHeight": "48",
    "paddingLeft": "16",
    "paddingRight": "16",
    "paddingTop": "2"
  },
  "mode-ICON": {
    "width": "32",
    "height": "32"
  },
  "type-ICON": {
    "width": "32",
    "height": "32"
  },
  "colmobtn-active-info": {
    "backgroundColor:active": "rgba(255,255,255,0.1)"
  },
  "colmobtn-active-important": {
    "backgroundColor:active": "rgba(179,83,54,0.1)"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-300644d8!./~/weex-vue-loader/lib/selector.js?type=styles&index=1!./packages/dof-noticebar/index.vue
// module id = 458
// module chunks = 0 1